/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.feature.reminders

import androidx.navigation.NavController
import androidx.navigation.NavGraphBuilder
import androidx.navigation.NavOptions
import androidx.navigation.toRoute
import kotlinx.serialization.Serializable
import studio.oddpods.cauce.core.base.ui.composableWithPushTransitions

@Serializable
data class RemindersRoute(val patientId: String? = null)

fun NavController.navigateToReminders(
    patientId: String? = null,
    navOptions: NavOptions? = null,
) = navigate(RemindersRoute(patientId), navOptions)

fun NavGraphBuilder.remindersDestination(onBackClick: () -> Unit) {
    composableWithPushTransitions<RemindersRoute> {
        val route = it.toRoute<RemindersRoute>()
        RemindersScreen(
            onBackClick = onBackClick,
            filterPatientId = route.patientId,
        )
    }
}
